module.exports = __webpack_public_path__ + "staticfr/media/minirobo.de26b4ed.mp4";